<template>
	<div :style="{ backgroundImage: `url(${mediaUrl})`, width:`1920px`, height:`1080px`, zIndex:-20}">
		<div v-if="isSoloVideo">
			<element-vcam-iframe v-if="!firstVirtualCam.is_ndi " :orderItem="1" :vcamItem="firstVirtualCam" :status="status" />
			<element-vcam-video-input v-if="firstVirtualCam.is_ndi " :orderItem="1" :vcamItem="firstVirtualCam" :status="status" v-show="!firstVirtualCam.is_empty_feed"/>
		</div>
		<div v-if="!isSoloVideo">
			<div v-html="svgContent" > </div>
			<div :style="{ zIndex: -20 }" >
				<div v-for="(virtualCam, index) in virtualCams" :key="virtualCam.id" class="d-flex justify-content-around" >
					<div v-if="checkIsPower(virtualCam)" :id="`panelist${virtualCam.id}`" :class="`panelistwrapper panelistwrapper${index+1} nineteentwenty`" :style="{ zIndex: 0 }">
						<svg v-if="checkIsPower(virtualCam)" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1920 1080" cursor="pointer" pointer-events="fill" >
							<foreignObject v-if="checkIsPower(virtualCam)" :id="`panelistobj${index+1}`" clip-path="url(#panelclipmask)" class="nineteentwenty" pointer-events="fill"  >
								<element-vcam-iframe v-if="!virtualCam.is_ndi " :orderItem="index+1" :layerIndex="localItem.layer_index" :vcamItem="virtualCam" :status="status" />
								<element-vcam-video-input v-if="virtualCam.is_ndi" :orderItem="index+1"  :layerIndex="localItem.layer_index" :vcamItem="virtualCam" :status="status" v-show="!virtualCam.is_empty_feed"/>
							</foreignObject>
						</svg>
					</div>
					<div id="panelistinfoset">
						<div :id="`pnlinfo${index+1}`" :class="`panelistinfo panelistinfo${index+1}`" v-if="status==='preview' && virtualCam.is_power" v-show="!virtualCam.is_hide_label"><span>
								<h1>{{ virtualCam.heading }}</h1>
								<h2>{{ virtualCam.sub_heading }}</h2>
							</span>
						</div>
						<div :id="`pnlinfo${index+1}`" :class="`panelistinfo panelistinfo${index+1}`" v-if="status==='live' " v-show="!virtualCam.is_hide_label"><span>
								<h1>{{ virtualCam.heading }}</h1>
								<h2>{{ virtualCam.sub_heading }}</h2>
							</span>
						</div>
					</div>
				</div>
			</div>
		</div>
    </div>
</template>

<script>
import { defaultStyleMulstiTwo } from '@/lib/statics';
import {
	delay,
	duplicateVar,
} from '@/lib/helper';
import 'vue-draggable-resizable/dist/VueDraggableResizable.css';
import ElementVcamIframe from '@/components/ElementVcamIframe.vue';
import ElementVcamVideoInput from '@/components/ElementVcamVideoInput.vue';

export default {
	name: 'ElementVCam',
	props: {
		item: {
			type: Object,
		},
		status: {
			type: String,
		},
	},
	components: {
		ElementVcamIframe,
		ElementVcamVideoInput,
	},
	sockets: {
		connect() {
			// this.activateSocket();
		},
		vcam_live_remove(id) {
			if (this.status === 'live') {
				this.removeItem(id);
			}
		},
		vcam_live_hide(vcamId) {
			// hide here
			this.toggleHide(vcamId);
		},
		vcam_live_turnOff(data) {
			// turn off here
			if (this.status === 'live') {
				const vCamId = data.id;
				this.removeItem(vCamId);
			}
		},
		vcam_live_turnOn(data) {
			// turn off here
			const rundownItem = data.rundownItem;
			this.insertItem(rundownItem);
		},
		vcam_live_muteAll(data) {
			const isMute = JSON.parse(data);
			if (isMute) {
				this.muteAll();
			} else {
				this.unmuteAll();
			}
		},
		vcam_live_mute(data) {
			const { id, status } = data;
			const isMuted = JSON.parse(status);
			if (isMuted) {
				this.mute(id);
			} else {
				this.unmute(id);
			}
		},
		vcam_live_solo(data) {
			const { status } = data;
			const isSolo = JSON.parse(status);
			if (isSolo && this.firstVirtualCam) {
				this.toggleHide(this.firstVirtualCam.id);
			}
		},
		force_play_item(data) {
			this.insertItem(data);
		},
	},
	created() {
		this.localItem = duplicateVar(this.item);
		this.getSVGContent().then((SVGtext) => {
			this.svgContent = (SVGtext);
		});
		const style = this.templateContent && this.templateContent.style ? this.templateContent.style : defaultStyleMulstiTwo;
		this.createStyle(`vcam-style-${this.item.id}`, style);
	},
	mounted() {
		// this.muteAll();
		const isMuteAll = this.content.isMutedAll;
		for (let index = 0; index < this.virtualCams.length; index++) {
			const item = this.virtualCams[index];
			if (this.status === 'live' && !item.is_power) {
				this.removeItem(item.id);
			}
			// console.log(item);
			if (!item.is_ndi) {
				const iframeLive = document.getElementById(`panelistifrmlive${item.order}`);
				const iframePreview = document.getElementById(`panelistifrmpreview${item.order}`);
				delay(() => {
					if (iframeLive && item.is_power) iframeLive.contentWindow.postMessage({ mute: item.is_mute || (item.is_empty_feed && item.is_hide_label) || isMuteAll }, '*'); // only work for obs ninja
					if (iframePreview && item.is_power) iframePreview.contentWindow.postMessage({ mute: item.is_mute || (item.is_empty_feed && item.is_hide_label) || isMuteAll }, '*'); // only work for obs ninja
				}, 3000);
			}
		}
	},
	beforeDestroy() {
		this.removeStyle(`vcam-style-${this.item.id}`);
	},
	data() {
		return {
			localItem: {},
			pnlidx: 0,
			isMultiView: true,
			camActiveIdx: 0,
			blankPnl: 'http://localhost/videosample/blank.html',
			placeholderPnl: 'http://localhost/videosample/pholder.html',
			activeCSS: '',
			cssFolder: 'css/',
			svgFolder: 'svg/',
			style2: defaultStyleMulstiTwo,
			svgContent: '',
			localStream: [],
		};
	},
	methods: {
		checkIsPower(vcamItem) {
			// console.log();
			return vcamItem && vcamItem.is_power;
		},
		async getSVGContent() {
			const svgPath = this.template && this.template.svg_path ? this.template.svg_path : '/img/vcam/coruscant2.svg';
			const svgContent = await (await fetch(svgPath)).text();
			return svgContent;
		},
		onDragstop() {
			// console.log('asdasdasd');
		},
		onResizestop() {

		},
		onDrag() {

		},
		onResize() {

		},
		insertItem(rundownItem) {
			if (this.status === 'live') {
				this.localItem = duplicateVar(rundownItem);
			}
			delay(() => {
				for (let index = 0; index < this.virtualCams.length; index++) {
					const item = this.virtualCams[index];
					const iframeLive = document.getElementById(`panelistifrmlive${item.order}`);
					const iframePreview = document.getElementById(`panelistifrmpreview${item.order}`);
					if (iframeLive) iframeLive.contentWindow.postMessage({ mute: item.is_mute || (item.is_empty_feed && item.is_hide_label) }, '*'); // only work for obs ninja
					if (iframePreview) iframePreview.contentWindow.postMessage({ mute: item.is_mute || (item.is_empty_feed && item.is_hide_label) }, '*'); // only work for obs ninja
				}
			}, 1000);
		},
		muteAll() {
			for (let index = 0; index < this.virtualCams.length; index++) {
				const item = this.virtualCams[index];
				const iframeLive = document.getElementById(`panelistifrmlive${item.order}`);
				const iframePreview = document.getElementById(`panelistifrmpreview${item.order}`);
				if (iframeLive) iframeLive.contentWindow.postMessage({ mute: true }, '*'); // only work for obs ninja
				if (iframePreview) iframePreview.contentWindow.postMessage({ mute: true }, '*'); // only work for obs ninja
			}
		},
		unmuteAll() {
			for (let index = 0; index < this.virtualCams.length; index++) {
				const item = this.virtualCams[index];
				const iframeLive = document.getElementById(`panelistifrmlive${item.order}`);
				const iframePreview = document.getElementById(`panelistifrmpreview${item.order}`);
				if (iframeLive) iframeLive.contentWindow.postMessage({ mute: item.is_mute || (item.is_empty_feed && item.is_hide_label) }, '*'); // only work for obs ninja
				if (iframePreview) iframePreview.contentWindow.postMessage({ mute: item.is_mute || (item.is_empty_feed && item.is_hide_label) }, '*'); // only work for obs ninja
			}
		},
		removeItem(vCamId) {
			const content = duplicateVar(this.content);
			const index = content.virtualCams.findIndex(({ id }) => id === vCamId);
			if (index !== -1) {
				content.virtualCams.splice(index, 1);
			}
			this.localItem.content = JSON.stringify(content);
		},
		toggleHide(vCamId) {
			const content = duplicateVar(this.content);
			const index = content.virtualCams.findIndex(({ id }) => id === vCamId);
			if (index !== -1) {
				if (this.status === 'live') {
					content.virtualCams[index].is_empty_feed = !content.virtualCams[index].is_empty_feed;
					content.virtualCams[index].is_hide_label = !content.virtualCams[index].is_hide_label;
					if (content.virtualCams[index].is_empty_feed && content.virtualCams[index].is_hide_label) {
						this.mute(vCamId);
					} else if (!content.virtualCams[index].is_mute && (!content.virtualCams[index].is_empty_feed && !content.virtualCams[index].is_hide_label)) {
						this.unmute(vCamId);
					}
				}
				if (this.status === 'preview') {
					if (content.virtualCams[index].is_empty_feed && content.virtualCams[index].is_hide_label) {
						this.mute(vCamId);
					} else if (!content.virtualCams[index].is_mute && (!content.virtualCams[index].is_empty_feed && !content.virtualCams[index].is_hide_label)) {
						this.unmute(vCamId);
					}
				}
			}
			this.localItem.content = JSON.stringify(content);
		},
		mute(vCamId) {
			const content = duplicateVar(this.content);
			const index = content.virtualCams.findIndex(({ id }) => id === vCamId);
			if (index !== -1) {
				const iframeLive = document.getElementById(`panelistifrmlive${content.virtualCams[index].order}`);
				const iframePreview = document.getElementById(`panelistifrmpreview${content.virtualCams[index].order}`);
				content.virtualCams[index].is_mute = true;
				delay(() => {
					if (iframeLive) iframeLive.contentWindow.postMessage({ mute: true }, '*'); // only work for obs ninja
					if (iframePreview && !content.virtualCams[index].is_ndi) iframePreview.contentWindow.postMessage({ mute: true }, '*'); // only work for obs ninja
				}, 500);
			}
			this.localItem.content = JSON.stringify(content);
		},
		unmute(vCamId) {
			const content = duplicateVar(this.content);
			const index = content.virtualCams.findIndex(({ id }) => id === vCamId);
			if (index !== -1) {
				const iframePreview = document.getElementById(`panelistifrmpreview${content.virtualCams[index].order}`);
				const iframeLive = document.getElementById(`panelistifrmlive${content.virtualCams[index].order}`);
				content.virtualCams[index].is_mute = false;
				delay(() => {
					if (iframeLive) iframeLive.contentWindow.postMessage({ mute: false }, '*'); // only work for obs ninja
					if (iframePreview && !content.virtualCams[index].is_ndi) iframePreview.contentWindow.postMessage({ mute: false }, '*'); // only work for obs ninja
				}, 500);
			}
			this.localItem.content = JSON.stringify(content);
		},
		initMute() {
			for (let index = 0; index < this.virtualCams.length; index++) {
				const item = this.virtualCams[index];
				const isMute = item.is_mute || (item.is_empty_feed && item.is_hide_label);
				if (isMute) {
					this.mute(item.id);
				} else {
					this.unmute(item.id);
				}
			}
		},
		activateSocket() {
			// this.$socket.client.emit('join', this.room);
		},
		panelistInfoVisible(flag = true) {
			$('#panelistinfoset').css('display', ((flag) ? 'block' : 'none'));
			return flag;
		},
		createStyle(id, content) {
			const style = document.createElement('style');
			style.innerHTML = content;
			style.setAttribute('id', id);
			document.body.appendChild(style);
		},
		removeStyle(id) {
			const styleVcam = document.getElementById(id);
			if (styleVcam) {
				styleVcam.remove();
			}
		},
	},
	computed: {
		content() {
			return this.localItem.content && this.localItem.content !== ''
				? JSON.parse(this.localItem.content) : {};
		},
		template() {
			let template = null;
			if (this.content && this.content.template) {
				template = this.content.template;
			}
			return template;
		},
		templateContent() {
			let content = null;
			if (this.template && this.template.content) {
				content = this.template.content && this.template.content !== ''
					? JSON.parse(this.template.content) : {};
			}
			return content;
		},
		firstVirtualCam() {
			const firstVcam = this.virtualCams.length > 0 ? this.virtualCams[0] : null;
			return firstVcam;
		},
		virtualCams() {
			let cams = [];
			if (this.content) {
				cams = this.content.virtualCams;
			}
			const vcamCount = this.templateContent && this.templateContent.vcam_count ? this.templateContent.vcam_count : 2;
			const maxVcams = cams.slice(0, vcamCount);
			const filteredMaxVcam = maxVcams.filter(vcam => vcam.is_power);
			// console.log(filteredMaxVcam);
			if (cams && cams.length > 0) return filteredMaxVcam;
			return [];
		},
		mediaUrl() {
			let mediaUrl = null;
			if (this.content && this.content.mediaUrl) {
				mediaUrl = this.content.mediaUrl;
			}
			return mediaUrl;
		},
		isSoloVideo() {
			return this.content.isSoloVideo;
		},
		className() {
			return this.content.position ? this.content.position : '';
		},
		style() {
			const style = {};
			style.position = 'absolute';
			style.border = '0';
			style.zIndex = this.localItem.layer_index;
			const content = this.content;
			if (content.opacity) style.opacity = content.opacity;
			// if (content.width) style.width = `${content.width}px`;
			// if (content.height) style.height = `${content.height}px`;
			// if (content.y) style.top = `${content.y}px`;
			// if (content.x) style.left = `${content.x}px`;
			return style;
		},
	},
	watch: {
		item() {
			if (this.item) {
				this.localItem = duplicateVar(this.item);
			}
		},

	},
};
</script>

<style lang="css" v-html="" scoped>
@import url("https://fonts.googleapis.com/css?family=Open+Sans+Condensed:300");
html, body {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  background-image: linear-gradient(rgba(200, 200, 200, 0.1) 0.1em, transparent 0.1em), linear-gradient(90deg, rgba(200, 200, 200, 0.1) 0.1em, transparent 0.1em);
}

.twelveeighty {
  width: 1280px !important;
  height: 720px !important;
}

.nineteentwenty {
  width: 1920px !important;
  height: 1080px !important;
}

button {
  height: 50px;
  background-color: #00FF00;
}

#buttonbar {
  position: absolute;
  bottom: 20px;
  left: 100px;
  z-index: 99999 !important;
}


</style>
